var moduleMap = {
	"./Sidebar": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_ant-design_icons_es_components_Icon_js-node_modules_antd_es_breadcrumb_i-ec5fd5"), __webpack_require__.e("vendors-node_modules_antd_es_form_index_js-node_modules_oidc-client_lib_oidc-client_min_js"), __webpack_require__.e("vendors-node_modules_ant-design_icons_es_icons_DoubleLeftOutlined_js-node_modules_ant-design_-87ac60"), __webpack_require__.e("src_store_configureStore_ts-node_modules_moment_locale_sync_recursive_-src_style_css-data_ima-aac91e"), __webpack_require__.e("src_Sidebar_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/Sidebar */ "./src/Sidebar.tsx")))));
	},
	"./Unauthorised": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_ant-design_icons_es_components_Icon_js-node_modules_antd_es_breadcrumb_i-ec5fd5"), __webpack_require__.e("src_store_configureStore_ts-node_modules_moment_locale_sync_recursive_-src_style_css-data_ima-aac91e"), __webpack_require__.e("src_Unauthorised_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/Unauthorised */ "./src/Unauthorised.tsx")))));
	},
	"./Profile": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_ant-design_icons_es_components_Icon_js-node_modules_antd_es_breadcrumb_i-ec5fd5"), __webpack_require__.e("vendors-node_modules_antd_es_form_index_js-node_modules_oidc-client_lib_oidc-client_min_js"), __webpack_require__.e("src_store_configureStore_ts-node_modules_moment_locale_sync_recursive_-src_style_css-data_ima-aac91e"), __webpack_require__.e("src_Profile_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/Profile */ "./src/Profile.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});